import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { AltTransMeasureProgress } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { Nullish } from "shared/utils/objectUtils";

export function useAlternativeTransportMeasureProgress(
  incidentId: Nullish<string>,
  fromTime?: Nullish<Date>,
  toTime?: Nullish<Date>,
  isRush?: Nullish<boolean>,
) {
  const { data, status, refetch, isRefetching } = useQuery({
    queryKey: [
      "alternativeTransport",
      "measureProgress",
      incidentId,
      fromTime,
      toTime,
      isRush,
    ],
    enabled: Boolean(incidentId),
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<AltTransMeasureProgress>(
        `${getBackendUrl()}/alternative-transport-planning/incident/${incidentId}/measure-progress`,
        {
          signal,
          params: {
            fromTime,
            toTime,
            isRush,
          },
        },
      );
      return response.data;
    },
    refetchInterval: 60 * 1000, // Every minute
    retry: false,
  });

  return { data, status, refetch, isRefetching };
}
